import Image from '@components/Image';
import useEditingStore from '@hooks/useEditingStore';
import useLangString from '@hooks/useLangString';
import {
  customIconDefaultMap,
  customIconLegacyDefaultMap,
} from '@modules/player/constants';
import { $templateId, $tourData } from '@stores/dataStores';
import {
  $GateEditingCustomIcons,
  $GateEditingLikeBtnActive,
  $editingFlag,
  $editingUIColor,
} from '@stores/editingStores';
import {
  type EditConfigCustomIcons,
  ImageType,
  MediaType,
  TemplateId,
} from '@types';
import { getTemplateConfig } from '@utils/templateConfig';
import { useStore } from 'effector-react';

function WInfoButtons() {
  const templateId = useStore($templateId);
  const flag = useEditingStore({
    $data: $tourData,
    dataFn: (state) => state.flag,
    $editing: $editingFlag.store,
  });
  const icons = useEditingStore({
    $data: $tourData,
    dataFn: (state) => state.config?.customIcons ?? {},
    $editing: $GateEditingCustomIcons.state,
  });
  const isLikeBtnActive = useStore($GateEditingLikeBtnActive.state);
  const ui = useEditingStore({
    $data: $tourData,
    dataFn: (state) => {
      const defaultUI = getTemplateConfig(templateId)('uiColor');
      if (!defaultUI) return null;
      const ui = state.config?.ui;
      if (!ui) return defaultUI;
      return { ...defaultUI, ...ui };
    },
    $editing: $editingUIColor.store,
  });

  const showRemark = !!(flag?.showTourRemark ?? 1);
  const showShare = !!(flag?.showShareBtn ?? 1);
  const showLike = !!(flag?.showLikeBtn ?? 1);
  const showCommentBtn = !!(flag?.showCommentBtnV2 ?? 1);

  const lang = useLangString(
    {
      intro: ['简介', 'Synopsis'],
      share: ['分享', 'Share'],
      like: ['赞', 'Like'],
      comment: ['留言', 'Comment'],
    },
    []
  );

  const renderBtn = (key: keyof EditConfigCustomIcons, title: string) => {
    const icon = icons[key];
    const size = templateId === TemplateId.legacy ? 36 : 40;

    return (
      <div className="ml-30 flex flex-col items-center">
        <Image
          style={{ height: `${size}px`, width: `${size}px` }}
          src={
            icon?.mediaUrl ||
            (templateId === TemplateId.legacy
              ? customIconLegacyDefaultMap[key]
              : customIconDefaultMap[key])
          }
          type={
            icon?.type === MediaType.lib ? ImageType.media : ImageType.sysMedia
          }
        />
        <div
          className="mt-5 text-sm"
          style={ui ? { color: `rgba(${ui.fontColor})` } : undefined}
        >
          {title}
        </div>
      </div>
    );
  };

  return (
    <div
      style={{
        display: 'flex',
        position: 'absolute',
        right: '20px',
        bottom: `${templateId === TemplateId.legacy ? 5 : 20}px`,
      }}
    >
      {showRemark && renderBtn('remarkBtn', lang.intro)}
      {showShare && renderBtn('shareBtn', lang.share)}
      {showLike &&
        (isLikeBtnActive
          ? renderBtn('likeBtnActive', lang.like)
          : renderBtn('likeBtn', lang.like))}
      {showCommentBtn && renderBtn('commentBtn', lang.comment)}
    </div>
  );
}

export default WInfoButtons;
